import { render, staticRenderFns } from "./RoleDetailsContainer.vue?vue&type=template&id=cb4c7934"
import script from "./RoleDetailsContainer.vue?vue&type=script&lang=js"
export * from "./RoleDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports